import { useRef } from 'react';
import { Icon } from '../atoms/Icon';
import PHTile from '../atoms/PHTile';
import { catColors } from '../atoms/catColors';

const MODELS = [
  { n: 'Flux 1.1 Ultra',    cat: 'Image', from: '$0.004 / image' },
  { n: 'Kling Video 3.0',   cat: 'Video', from: '$0.04 / second' },
  { n: 'Veo 3',             cat: 'Video', from: '$0.08 / second' },
  { n: 'GPT Image 2',       cat: 'Image', from: '$0.012 / image' },
  { n: 'Wan 2.7',           cat: 'Video', from: '$0.03 / second' },
  { n: 'Luma Ray 2',        cat: 'Video', from: '$0.06 / second' },
  { n: 'Nano Banana Flash', cat: 'Image', from: '$0.002 / image' },
  { n: 'SDXL',              cat: 'Image', from: '$0.003 / image' },
  { n: 'Gemini Flash',      cat: 'Text',  from: '$0.0001 / 1K tok' },
  { n: 'GPT-4.1',           cat: 'Text',  from: '$0.005 / 1K tok' },
  { n: 'Seedance 2.0',      cat: 'Video', from: '$0.05 / second' },
  { n: 'Juggernaut',        cat: 'Image', from: '$0.004 / image' },
];

function ModelCard({ m, i }) {
  const c = catColors(m.cat);
  return (
    <div className="card" style={{ width: 268, flex: '0 0 268px', padding: 14, display: 'flex', flexDirection: 'column', gap: 12, position: 'relative', overflow: 'hidden' }}>
      <div style={{ position: 'absolute', inset: '-30% -10% auto auto', height: '70%', width: '60%', background: `radial-gradient(circle at 70% 30%, ${c.from}, transparent 65%)`, filter: 'blur(10px)', pointerEvents: 'none' }}/>
      <PHTile label={`sample #${i + 1}`} kind={m.cat === 'Video' ? 'video' : 'image'} from={c.from} to={c.to} ratio={16 / 10}/>
      <div className="row" style={{ justifyContent: 'space-between', alignItems: 'center' }}>
        <div style={{ fontSize: 14, fontWeight: 600, letterSpacing: '-0.01em' }}>{m.n}</div>
        <span className="chip" style={{ height: 22, padding: '0 8px', fontSize: 11, color: c.label, borderColor: c.ring, background: 'rgba(255,255,255,.04)' }}>{m.cat}</span>
      </div>
      <div className="row" style={{ justifyContent: 'space-between', alignItems: 'center', color: 'var(--text-3)', fontSize: 12 }}>
        <span>from <span className="mono" style={{ color: 'var(--text-2)' }}>{m.from}</span></span>
        <span style={{ color: c.label, display: 'inline-flex', alignItems: 'center', gap: 4 }}>Run <Icon.arrow size={12}/></span>
      </div>
    </div>
  );
}

export default function ModelShowcase() {
  const railRef = useRef(null);
  const scrollBy = (dx) => railRef.current?.scrollBy({ left: dx, behavior: 'smooth' });

  return (
    <section id="models">
      <div className="container">
        <div className="row" style={{ justifyContent: 'space-between', alignItems: 'flex-end', flexWrap: 'wrap', gap: 16 }}>
          <div>
            <div className="eyebrow" style={{ marginBottom: 14 }}>Model library</div>
            <h2 className="h2" style={{ maxWidth: '18ch' }}>50+ models. <span className="grad-text">One balance.</span></h2>
            <p className="lede" style={{ marginTop: 18, maxWidth: '60ch' }}>
              Stop managing subscriptions to Midjourney, Runway, and Kling separately.
              Everything is here, priced transparently per generation.
            </p>
          </div>
          <div className="row gap-2">
            <button className="btn btn-ghost btn-sm" onClick={() => scrollBy(-540)} aria-label="Scroll left">‹</button>
            <button className="btn btn-ghost btn-sm" onClick={() => scrollBy(540)} aria-label="Scroll right">›</button>
          </div>
        </div>
      </div>

      <div style={{ marginTop: 40, position: 'relative' }}>
        <div ref={railRef} className="no-scrollbar" style={{
          display: 'flex', gap: 16, overflowX: 'auto', scrollSnapType: 'x mandatory',
          padding: '4px 32px 8px',
          paddingLeft: 'max(32px, calc((100vw - 1240px)/2 + 32px))',
          paddingRight: 'max(32px, calc((100vw - 1240px)/2 + 32px))',
        }}>
          {MODELS.map((m, i) => (
            <div key={m.n} style={{ scrollSnapAlign: 'start' }}>
              <ModelCard m={m} i={i}/>
            </div>
          ))}
          <div style={{ flex: '0 0 268px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <a href="/explore" className="row gap-2" style={{ color: '#fff', fontWeight: 600, fontSize: 14, textDecoration: 'none', padding: '14px 18px', borderRadius: 14, background: 'rgba(255,255,255,.04)', border: '1px solid var(--border)' }}>
              See all 50+ models <Icon.arrow/>
            </a>
          </div>
        </div>
        <div style={{ position: 'absolute', left: 0, top: 0, bottom: 0, width: 80, pointerEvents: 'none', background: 'linear-gradient(90deg, var(--bg), transparent)' }}/>
        <div style={{ position: 'absolute', right: 0, top: 0, bottom: 0, width: 80, pointerEvents: 'none', background: 'linear-gradient(-90deg, var(--bg), transparent)' }}/>
      </div>
    </section>
  );
}
